import React, {useMemo} from "react";
import { DeleteOutlined } from "@ant-design/icons";
import SearchComponent from "../../../../../v2-components/Search";
import CustomTable from "../../../../../v2-components/Antd/Table";
import CustomInputNumber from "../../../../../v2-components/Antd/InputNumber";
import CustomButton from "../../../../../v2-components/Antd/Button";


const ProductSection = ({ 
  products, 
  onDeleteProduct, 
  onUpdateQuantity ,
  isSearchVisible,
  status
}) => {

  const hasProducts = products && products.length > 0;

  const dataSource = useMemo(() => {
    return (products || []).map((item) => {
      const detail = item.product_detail || {};
      
      return {
        ...item, 
         sku:  item.sku || item.id_pharol,
         image: item.image ||  detail.original_image,
        editable_name: item.editable_name || detail.editable_name,
        laboratory: item.laboratory || detail.laboratory,
        promotion_price: item.promotion_price ||  detail.promotion_price,
        price: Number(item.price || detail.price),
        quantity: Number(item.quantity),
      };
    });
  }, [products]);

   console.log('datasource',dataSource)

  const columns = [
    {
      title: "Nombre del producto",
      dataIndex: "editable_name",
      key: "editable_name",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={record.image}
            alt={record.editable_name}
            style={{ width: 50, height: 50, marginRight: 10 }}
          />
          <div>
            <div style={{ fontSize: 12 }}>
               {record.editable_name} <br />
               Laboratorio: {record.laboratory} <br />
              Sku farmacia: {record.sku}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
      render: (_, record) => (
        <CustomInputNumber
        disabled={status!==100}
          min={1}
          value={record.quantity}
          onChange={(newValue) => onUpdateQuantity(record.sku, newValue)}
        />
      ),
    },
    {
      title: "Precio u.",
      dataIndex: "price",
      key: "price",
      render: (val) => `$${val}`,
    },
    {
      title: "Desc. u.",
      dataIndex: "discount",
      key: "discount",
      render: (val, record) => `$${record.price - record.promotion_price}`,
    },
    {
      title: "Precio final u.",
      dataIndex: "promotion_price",
      key: "promotion_price",
      render: (val) => `$${val}`,
    },
    {
      title: "Precio final",
      dataIndex: "total",
      key: "total",
      render: (_, record) => `$${record.promotion_price * record.quantity}`,
    },
    {
      title: "Eliminar",
      key: "actions",
      render: (_, record) => (
        <CustomButton
        disabled={status!==100}
          type="text"
          icon={<DeleteOutlined />}
          onClick={() => onDeleteProduct(record.sku)}
        />
      ),
    },
  ];

  if (!isSearchVisible && !hasProducts) {
    return null;
  }

  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: 8,
        padding: 16,
        marginTop: 16,
      }}
    >
      {isSearchVisible && (
      <div style={{ marginBottom: 16, position: "relative" }}>
        <label style={{ display: "block", marginBottom: 4 }}>
          Buscar producto por nombre
        </label>
        <SearchComponent pharmacy={'narma'}  disabled={status!==100}
 />
      </div>
        )}
      <div style={{ position: "relative", zIndex: 1 }}>
        <CustomTable
          columns={columns}
          dataSource={dataSource}
          rowKey="sku"
          pagination={false}
          locale={{
            emptyText: (
              <div style={{ padding: '20px 0', color: '#999' }}>
                <span>Aún no has agregado productos comerciales a tu receta.</span>
              </div>
            )
          }}
        />
      </div>
    </div>
  );
};

export default ProductSection;